import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';
import { SERVER_BASE_URL } from '../environment.token';


@Component({
  selector: 'ca-quiz-list',
  imports: [CommonModule, ProgressBarComponent],
  template: `
  <div id="quiz-list">
    <!-- @for (quiz of data?.content; track $index) { -->
      <ng-container *ngFor="let quiz of data?.content">
      <ng-template #quizItemContent>
      <img [src]="base + quiz.image.src" [alt]="quiz.image.alt" />
        <div class="quiz-info">
          <h3>{{ quiz.title }}</h3>
          <p>{{ quiz.author }}</p>
          <ca-progress-bar [progress]="quiz.difficulty / 10"></ca-progress-bar>
          <div class="quiz-tags">
            @for (tag of quiz.tags; track $index) {
              <span class="quiz-tag">{{ tag }}</span>
            }
          </div>
          <span class="info-block-cta material-symbols-outlined"> more_vert </span>
        </div>
      </ng-template>
      @if (quiz.href) {
        <a class="quiz-item" [href]="quiz.href" target="_blank">
          <ng-container [ngTemplateOutlet]="quizItemContent"></ng-container>
        </a>
      }
      @else {
        <div class="quiz-item">
          <ng-container [ngTemplateOutlet]="quizItemContent"></ng-container>
        </div>
      }
      </ng-container>
    <!-- } -->
  </div>`,
})
export class QuizListComponent {
  @Input() data?: QuizListData;
  readonly base = inject(SERVER_BASE_URL);
}

export interface QuizListItemData {
  title: string;
  author: string;
  image: {
    src: string;
    alt: string;
  };
  difficulty: number; // 1 tot 10
  tags: string[];
  href: string; // externe link URL naar typeform
}

export interface QuizListData {
  cssClass: null | string;
  content: QuizListItemData[];
}
